import { useEffect, useState } from "react";
import { icons } from "../../constants";

const Search = (props: any) => {
  const {
    onChange,
    name,
    onClick,
    onKeyDown,
    id,
    className,
    placeholder,
    value,
    onClear,
  } = props;

  const [localValue, setLocalValue] = useState(value || "");

  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  const handleChange = (e: any) => {
    setLocalValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  const handleClear = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setLocalValue("");
    if (onClear) {
      onClear();
    }
    if (onChange) {
      onChange({
        target: {
          name: name || "",
          value: "",
        },
      });
    }
  };

  const currentValue = value !== undefined ? value : localValue;
  const hasValue = Boolean(currentValue && String(currentValue).length > 0);

  return (
    <>
      <div className="col-12 col-md-4 ms-auto">
        <div className="form-group mb-0 search-input position-relative">
          <div className="icon">
            {hasValue ? (
              <i
                className={`icon ${icons.ICON_CLOSE || "icon-close"}`}
                onClick={handleClear}
                style={{
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#333",
                }}
                title="Clear"
              ></i>
            ) : (
              <i
                className={`icon ${icons.ICON_SEARCH}`}
                onClick={onClick}
                style={{ cursor: onClick ? "pointer" : "default" }}
              ></i>
            )}
          </div>
          <input
            type="text"
            className={className || "form-control bg-white"}
            placeholder={placeholder}
            id={id}
            name={name}
            value={currentValue || ""}
            onKeyDown={onKeyDown}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

export default Search;
